import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "px-10 mt-4" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs" }, "Transcript:", -1)
const _hoisted_4 = { class: "text-xs" }
const _hoisted_5 = { class: "mt-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, " Call history ", -1)
const _hoisted_7 = { class: "flex items-center relative text-xs" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "ml-px h-2 w-2 rounded-full bg-dark-blue-400 mr-2" }, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "absolute w-px h-8 bg-dark-blue-400 left-1 -bottom-6"
}
const _hoisted_10 = { class: "text-xs text-gray-400" }

import {
	ConversationCallMessage,
	useMessaging
} from '@/inbox/composition';
import { UiAudio } from '@/ui-kit';
import { differenceInSeconds } from 'date-fns';


export default /*#__PURE__*/_defineComponent({
  __name: 'CallFullMessage',
  props: {
    message: null
  },
  setup(__props: any) {

const props = __props as {
	message: ConversationCallMessage;
};



function formatCallDuration() {
	const duration = props.message.content.call_duration;
	const minutes = Math.floor((duration / 60) % 60);
	const seconds = duration % 60;

	let message = '';

	if (minutes) {
		message += minutes.toString().endsWith('1')
			? `${minutes} minute `
			: `${minutes} minutes `;
	}

	if (seconds) {
		message += seconds.toString().endsWith('1')
			? `${seconds} second `
			: `${seconds} seconds `;
	}

	return message;
}

const { dateFormat } = useMessaging();

function getStatus(status: { status: string }) {
	const formattedStatus = status.status.replace(
		/[.-_]/g,
		' '
	);
	return `Call ${formattedStatus}`;
}

function getDiff(
	prev: { created_at: string },
	next: { created_at: string }
) {
	const seconds = differenceInSeconds(
		new Date(prev.created_at),
		new Date(next.created_at)
	);

	if (seconds === 0) {
		return null;
	}

	if (seconds < 60) {
		return `${seconds} seconds`;
	}

	const minutes = Math.floor(seconds / 60);

	if (minutes < 60) {
		return `${minutes} minutes ${seconds % 60} seconds`;
	}

	const hours = Math.floor(minutes / 60);

	return `${hours} hours ${minutes} minutes`;
}

function getDate(status: string) {
	return dateFormat(status)
		?.split(', ')
		.reverse()
		.join(', ');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.message.content.records, (record, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: i,
        class: "flex flex-col gap-2"
      }, [
        (record.transcriptionText)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("p", null, _toDisplayString(record.transcriptionText), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(record.type === 'voicemail'
							? 'Voicemail:'
							: 'Call recording:'), 1),
          _createVNode(_unref(UiAudio), {
            withDownload: "",
            class: "!mb-0",
            noRemove: "",
            noChange: "",
            name: "audio",
            modelValue: record.recordingUrl
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("span", null, "Call duration: " + _toDisplayString(formatCallDuration()), 1)
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.message.content
					.statuses, (status, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "flex mt-4 items-center justify-between px-4",
          key: i
        }, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", null, [
              _createTextVNode(_toDisplayString(getStatus(status)) + " ", 1),
              (status.user?.name)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("(" + _toDisplayString(status.user?.name) + ")", 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            (
							i !==
							__props.message?.content.statuses
								.length -
								1
						)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            (
							__props.message?.content.statuses[
								i + 1
							] && i !== 0
						)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(getDiff(
								__props.message?.content.statuses[
									i + 1
								],
								status
							)), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(getDate(status.created_at)), 1)
                ], 64))
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})